import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getVendorRemittance = createAsyncThunk(
  "app/getVendorRemittance",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };

    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/remittance/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const updateVendorRemittancePayment = createAsyncThunk(
  "app/updateVendorRemittancePayment",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/remittance`, body, config);
      successAlertHandle("Action submitted successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getVendorRemittancePaymentReport = createAsyncThunk(
  "app/getVendorRemittancePaymentReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/remittance/payment/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);
